export function getBackofficeLoginRedirectPath({
  pathname,
  isLoggedIn,
}: {
  pathname: string;
  isLoggedIn: boolean;
}): string | undefined {
  if (!isLoggedIn && pathname !== "/login") {
    return "/login";
  }
  if (isLoggedIn && pathname === "/login") {
    return "/";
  }
  return undefined;
}
